export const confirm = async (action, _datastore, { asyncStorage, goBack, setDatastore, navigate, ...props }) => {
    await goBack();
};
